import { useI18n } from 'vue-i18n'
import { createTrendsState } from './state'
import { createFetchTrends } from './methods/fetch-trends'
import { createSelectTrend } from './methods/select-trend'
import { createSetTrendType } from './methods/set-trend-type'
import { trendsService } from '../../services/trends/trends-service'

/**
 * Composable for trends management
 * @returns {Object} Trends state and methods
 */
export function useTrends() {
  const { t } = useI18n()
  
  // Create state
  const state = createTrendsState()
  
  // Create methods
  const fetchTrends = createFetchTrends(state)
  const selectTrend = createSelectTrend(state)
  const setTrendType = createSetTrendType(state)
  
  // Export utilities from service
  const { 
    formatTimeDisplay, 
    formatVolumeDisplay,
    getTrendFilterItems,
    TREND_KEYWORD_TYPES 
  } = trendsService
  
  // Return public API
  return {
    // State
    isLoadingTrends: state.isLoadingTrends,
    trendsList: state.trendsList,
    selectedTrend: state.selectedTrend,
    selectedTrendType: state.selectedTrendType,
    
    // Constants
    TREND_KEYWORD_TYPES,
    
    // Methods
    fetchTrends,
    selectTrend,
    setTrendType,
    
    // Utilities
    formatTimeDisplay,
    formatVolumeDisplay,
    getTrendFilterItems: () => getTrendFilterItems(t),
  }
}
